<template>
    <div class="curtain-grey">
        <div class="body-repeat-end">
            <div class="border-repeat-end">
                <div class="text-title">
                    <div class="text-clear my-cursor" @click.stop="saveClear">永不结束</div>
                    结束重复
                </div>
                <div class="items-type">
                    <div class="item-type my-cursor"
                         @click.stop="setEndType(typeItem.type)"
                         v-for="(typeItem, typeIndex) in typeItems">
                        <div class="text-type">{{ typeItem.text }}</div>
                        <div class="img-repeat-line" :style="{visibility: typeItem.type === endType ? 'visible': 'hidden'}"></div>
                    </div>
                </div>
                <div class="scroll-box" v-show="endType === 'date'">
                    <div class="scroll-year">
                        <ScrollModule :items="yearArray" :selected="year" @submitEvent="setYear($event)"/>
                    </div>
                    <div class="text-item">年</div>
                    <div class="scroll-month">
                        <ScrollModule :items="monthArray" :selected="month" @submitEvent="setMonth($event)"/>
                    </div>
                    <div class="text-item">月</div>
                    <div class="scroll-day">
                        <ScrollModule :items="dayArray" :selected="day" @submitEvent="setDay($event)"/>
                    </div>
                    <div class="text-item">日</div>
                </div>
                <div class="scroll-box" v-show="endType === 'number'">
                    <div class="scroll-number">
                        <ScrollModule :items="numberArray" :selected="number" @submitEvent="setNumber($event)"/>
                    </div>
                    <div class="text-item">次</div>
                </div>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from "@/pages/List/MatterInfo/ScrollModule";
export default {
    name: "SettingRepeatEnd",
    components: {
        ScrollModule,
    },
    data(){
        return {
            endType: "",
            typeItems: [
                {
                    type: "date",
                    text: "按日期",
                }, {
                    type: "number",
                    text: "按次数",
                }
            ],
            yearArray: [],
            monthArray: [],
            dayArray: [],
            year: "",
            month: "",
            day: "",
            startYear: 0,
            startMonth: 0,
            startDay: 0,
            numberArray: [],
            number: "",
        }
    },
    props: {
        startDate: {
            type: "",
            default: "",
        },
        repeatEndType: {
            type: "",
            default: "",
        },
        repeatEndInfo: {
            type: String,
            default: "",
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            let repeatEndInfo;
            if(this.endType === "date"){
                repeatEndInfo = this.year + "-" + this.$Utils.addZero(this.month) + "-" + this.$Utils.addZero(this.day);
            }else{
                repeatEndInfo = this.number;
            }
            this.$emit("submitEvent", {repeatEndType: this.endType, repeatEndInfo: repeatEndInfo});
            this.close();
        },
        saveClear: function(){
            this.$emit("submitEvent", {repeatEndType: "", repeatEndInfo: ""});
            this.close();
        },
        setYearArray: function(){
            const yearArray = [];
            for (let i=this.startYear; i<2051; i++){
                yearArray.push(i.toString());
            }
            this.yearArray = yearArray;
        },
        setMonthArray: function(){
            const monthArray = [];
            for(let i=1; i< 13; i++){
                monthArray.push(i.toString())
            }
            this.monthArray = monthArray;
        },
        setDayArray: function(year, month){
            const days = SolarMonth.fromYm(year, month).getDays();
            const dayArray = [];
            days.forEach((item)=>{
                const day = item.getDay();
                dayArray.push(day.toString());
            })
            this.dayArray = dayArray;
        },
        setNumberArray: function(){
            const numberArray = [];
            for (let i=1; i<100; i++){
                numberArray.push(i.toString())
            }
            this.numberArray = numberArray;
        },
        setEndType: function(endType){
            this.endType = endType;
        },
        setYear: function(year){
            this.year = year;

            if(parseInt(this.year) === this.startYear){
                if(parseInt(this.month) < this.startMonth
                    || (parseInt(this.month) === this.startMonth
                        && parseInt(this.day) < this.startDay)
                ){
                    this.toStartDate()
                    return
                }
            }
            const currentDay = this.day;
            this.day = "1";
            this.setDayArray(parseInt(this.year), parseInt(this.month));
            if(this.dayArray.indexOf(currentDay) > -1){
                this.day = currentDay
            }
        },
        setMonth: function(month){

            this.month = month;

            if(parseInt(this.year) === this.startYear){
                if(parseInt(this.month) < this.startMonth
                    || (parseInt(this.month) === this.startMonth
                        && parseInt(this.day) < this.startDay)
                ){
                    this.toStartDate()
                    return
                }
            }

            const currentDay = this.day;
            this.day = "1";
            this.setDayArray(parseInt(this.year), parseInt(month));
            if(this.dayArray.indexOf(currentDay) > -1){
                setTimeout(()=>{
                    this.day = currentDay
                });
            }
        },
        setDay: function(day){
            this.day = day;
            if(parseInt(this.year) === this.startYear
                && parseInt(this.month) === this.startMonth
                && parseInt(day) < this.startDay){
                setTimeout(()=>{
                    this.day = this.startDay.toString();
                }, 200)
            }
        },
        toStartDate: function(){
            setTimeout(()=>{
                this.setDayArray(parseInt(this.year), parseInt(this.startMonth));
                this.month = this.startMonth.toString();
                this.day = this.startDay.toString();
            }, 200)
        },
        setNumber: function(number){
            this.number = number;
        },
    },
    created(){
        let startDate;
        if(this.startDate === ""){
            startDate = new Date();
        }else{
            startDate = new Date(this.startDate);
        }
        let year = startDate.getFullYear();
        let month = startDate.getMonth() + 1;
        let day = startDate.getDate();

        this.startYear = year;
        this.startMonth = month;
        this.startDay = day;

        this.setYearArray();
        this.setMonthArray();
        this.setDayArray(year, month);

        this.setNumberArray();
    },
    mounted(){
        let endType, endDate, number;
        if(this.repeatEndType === ""){
            endType = "date";
            number = "1";
            endDate = new Date();

        }else if(this.repeatEndType === "date"){
            endType = "date";
            number = "1";
            endDate = new Date(this.repeatEndInfo);
        }else{
            endType = "number";
            number = this.repeatEndInfo;
            endDate = new Date();
        }
        console.log("endType:", this.repeatEndType);
        this.year = endDate.getFullYear().toString();
        this.month = (endDate.getMonth() + 1).toString();
        this.day = endDate.getDate().toString();
        this.number = number;
        this.endType = endType;
    },
}
</script>

<style scoped>
div.body-repeat-end{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}
div.border-repeat-end{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    width: 100%;
    height: 0.22rem;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
    position: relative;
}
div.text-clear{
    position: absolute;
    right: 0;
    color: #FC8470;
    font-size: 0.16rem;
}
div.items-type{
    width: 100%;
    padding: 0 0.8rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    margin-top: 0.24rem;
}
div.text-type{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}
div.img-repeat-line{
    width: 0.64rem;
    height: 0.07rem;
    background: url("../../../assets/images/List/img-time-line.png");
    background-size: cover;
    margin: -0.07rem auto auto;
}

div.scroll-box{
    width: 100%;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    margin-top: 0.2rem;
    box-sizing: border-box;
    padding: 0.2rem 0.3rem;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.1rem;

}
div.text-item{
    font-weight: bold;
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}

div.scroll-year, div.scroll-month, div.scroll-day, div.scroll-number{
    width: 0.6rem;
    height: 1.2rem;
    text-align: center;
}


div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>